export default __webpack_public_path__ + "static/media/sienas10-min.c6d94e06.jpg";